<template>
  <a-row type="flex" justify="center">
    <a-col :xl="20" :span="24">
      <div>
        <h2 style="margin-top:10px;padding-bottom:10px;border-bottom:1px solid black;">
          {{title}}
        </h2>
        <div v-for="section in topSections">
          <h4>{{section.title}}</h4>
          <ul>
            <li v-for="p in section.paragrahps">{{p}}</li>
          </ul>
        </div>
      </div>
      <a-row type="flex" justify="center">
        <a-col :span="12">
          <a-row type="flex" justify="center">
            <editor ref="editor" @output="outputHandler" />
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row type="flex" justify="center" style="margin-top:120px">
            <model-3d ref="model" />
          </a-row>
        </a-col>
      </a-row>

      <report-table :dataSource="reportData" @delete="reportDeleteHandler" />
    </a-col>
  </a-row>
</template>

<script>
import CONFIG from './config'
import Editor from './components/Editor'
import Model3D from './components/Model3D'
import ReportTable from './components/ReportTable'

export default {
  name: 'app',

  components: {
    'editor': Editor,
    'model-3d': Model3D,
    'report-table': ReportTable
  },

  data () {
    return {
      title: CONFIG.title,
      topSections: CONFIG.topSections,
      reportData: []
    }
  },

  methods: {
    outputHandler (canvas) {
      const { model, editor } = this.$refs
      Promise.all([
        model.getModelImage(),
        editor.getProjectionImage()
      ]).then(([modelImage, projectionImage]) => {
        this.reportData.push({
          key: Date.now(),
          model: modelImage,
          projection: projectionImage,
          ...model.getModelInfo()
        })
      })
    },
    reportDeleteHandler (record) {
      this.reportData = this.reportData.filter(r => r.key !== record.key)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.report .ant-table-tbody tr td,
.report .ant-table-body tr th {
  padding: 4px 2px !important;
  text-align: center !important;
}

.canvas {
  display: inline-block;
  background-image: url(~@/assets/images/stereo.png);
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.canvas .crystal-icon {
  display: none;
}

.crystal-icon {
  display: inline-block;
  width: 100px;
  height: 100px;
  border: 1px solid black;
  background-image: url(~@/assets/images/L6.png);
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

</style>



// WEBPACK FOOTER //
// src/App.vue